import { useState, useCallback } from 'react';
import type { FilterState, TenderType, Voivodeship } from '../types/filters';
import { DEFAULT_FILTERS } from '../types/filters';

export function useFilters() {
  const [filters, setFilters] = useState<FilterState>(DEFAULT_FILTERS);

  const setVoivodeship = useCallback((voivodeship: Voivodeship | null) => {
    setFilters((prev) => ({ ...prev, voivodeship }));
  }, []);

  const setTenderType = useCallback((tender_type: TenderType | null) => {
    setFilters((prev) => ({ ...prev, tender_type }));
  }, []);

  const setPriceRange = useCallback(
    (min_price: number | null, max_price: number | null) => {
      setFilters((prev) => ({ ...prev, min_price, max_price }));
    },
    []
  );

  const resetFilters = useCallback(() => {
    setFilters(DEFAULT_FILTERS);
  }, []);

  return {
    filters,
    setVoivodeship,
    setTenderType,
    setPriceRange,
    resetFilters,
  };
}
